<div class="fixed inset-0 z-[999997] flex flex-col items-center justify-center gap-3.5 bg-[var(--overlay-bg)] opacity-0 animate-[fade-in-delay_0.15s_ease_120ms_forwards]">
  <div class="size-[52px] rounded-full border-4 border-[color-mix(in_srgb,var(--primary)_25%,transparent)] border-t-[var(--primary)] animate-[rotate360_0.8s_linear_infinite]"></div>
  <div class="text-[15px] text-foreground">{{loadName()}}...</div>
</div>
